export type StatusKind = 'good' | 'attention' | 'critical' | 'info';

export function humanize(value: string): string {
  const spaced = value.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/** Maps a status word from the server to how it is shown. Unknown words are shown as they are, as information. */
export function describeStatus(value: string): { kind: StatusKind; label: string } {
  switch (value) {
    case 'Approved': case 'Settled': case 'Verified': case 'Active': case 'Filed': case 'No issues': case 'Available':
      return { kind: 'good', label: value };
    case 'PendingApproval': return { kind: 'attention', label: 'Pending approval' };
    case 'Pending': return { kind: 'attention', label: 'Pending verification' };
    case 'Needs attention': case 'Failed': case 'Rejected': case 'Unavailable':
      return { kind: 'critical', label: value };
    case 'PastDueGrace': return { kind: 'attention', label: 'Past due (grace period)' };
    case 'PastDueRestricted': return { kind: 'critical', label: 'Past due (restricted)' };
    case 'TrialExpired': return { kind: 'attention', label: 'Trial expired' };
    case 'TrialActive': return { kind: 'info', label: 'Trial' };
    case 'TrialNotStarted': return { kind: 'info', label: 'Trial not started' };
    case 'Submitted': return { kind: 'info', label: 'Awaiting settlement' };
    case 'None': return { kind: 'info', label: 'None' };
    default: return { kind: 'info', label: humanize(value) };
  }
}
